import React from 'react';
import { Tag, Button, Descriptions } from '@bedrock/components';
import classNames from 'classnames/bind';
import styles from './index.less';
import { HandRight, Mall } from '@bedrock/icons-react';
import { EllipsisTooltip, CellDescriptions } from '@mpc/components';

const cx = classNames.bind(styles);

type TagId = 'designated' | 'supplier_recommend';

/**
 * 可用的标签列表配置
 */
const AVAILABLE_TAGS = [
  {
    id: 'designated',
    name: '指定达人',
    color: 'light-orange' as const,
    icon: <HandRight />,
  },
  {
    id: 'supplier_recommend',
    name: '供应商推荐',
    color: 'light-blue' as const,
    icon: <Mall />,
  },
];

interface ExpertCellProps {
  /** 达人名称 */
  name?: string;
  /** 启用的标签ID列表 */
  enabledTags?: TagId[];
  /** 主平台链接 */
  link?: string;
  /** 主平台名称 */
  platform?: string;
  /** 主平台账号 */
  account?: string;
}

/**
 * 达人信息展示组件
 */
const ExpertCell: React.FC<ExpertCellProps> = ({
  name,
  enabledTags = [],
  link,
  platform,
  account,
}) => {
  // 根据启用的标签ID渲染标签
  const renderTags = () => {
    const tagsToShow = AVAILABLE_TAGS.filter((tag) =>
      enabledTags.includes(tag.id)
    );

    if (tagsToShow.length === 0) {
      return null;
    }

    return (
      <div className={cx('expert-tags')}>
        {tagsToShow.map((tag) => (
          <Tag
            key={tag.id}
            text={tag.name}
            color={tag.color}
            icon={tag.icon}
            border={true}
            size="xSmall"
          />
        ))}
      </div>
    );
  };

  return (
    <div className={cx('expert-cell')}>
      {(name || renderTags()) && (
        <div className={cx('expert-name')}>
          {name}
          {renderTags()}
        </div>
      )}
      <CellDescriptions
        column={1}
        maxDisplayCount={3}
        items={[
          platform && {
            label: '主平台',
            span: 1,
            children: <EllipsisTooltip clamp={1} text={platform} />,
          },
          account && {
            label: '主平台发布账号',
            span: 1,
            children: <EllipsisTooltip clamp={1} text={account} />,
          },
          link && {
            label: '主平台链接',
            span: 1,
            children: (
              <Button
                type="link"
                size="small"
                href={link}
                target="_blank"
                className="visited:text-[var(--status-info-1)]"
              >
                <EllipsisTooltip clamp={1} text={link} />
              </Button>
            ),
          },
        ].filter(Boolean)}
      />
    </div>
  );
};

export default ExpertCell;
